// @flow
import invariant from 'invariant';

/*
 * styled-components mixins
 */

// Generates a media query to target HiDPI devices.
export const hiDPI = (ratio: number = 2) => `
    @media only screen and (-webkit-min-device-pixel-ratio: ${ratio}),
    only screen and (min--moz-device-pixel-ratio: ${ratio}),
    only screen and (-o-min-device-pixel-ratio: ${ratio}/1),
    only screen and (min-resolution: ${96 * ratio}dpi),
    only screen and (min-resolution: ${ratio}dppx)
  `;

export const retinaBackgroundImage = (
  filename: string,
  {
    include3x = true,
    filename2x,
    filename3x
  }: {
    include3x?: boolean,
    filename2x?: string,
    filename3x?: string
  } = {}
) => {
  if (!filename2x) {
    const match = filename.match(/\.(png|jpg)$/);
    invariant(
      match,
      `Invalid filename "${filename}" File must be a PNG or JPG.`
    );
    const suffix = match[1];
    filename2x = filename.replace(`.${suffix}`, `@2x.${suffix}`);
    if (include3x && !filename3x) {
      filename3x = filename.replace(`.${suffix}`, `@3x.${suffix}`);
    }
  }
  let css = `
    background-image: url(${filename});
    ${hiDPI()}: {
      background-image: url(${filename2x});
    }
  `;
  if (filename3x) {
    css += `
      ${hiDPI(3)}: {
        background-image: url(${filename3x});
      }
    `;
  }
  return css;
};

const hexCodes = {
  black: '#000',
  white: '#FFF'
};

export const getRgbaString = (hex: string, opacity: number | string) => {
  const hexCode = hex.replace('#', '');
  const fullHex =
    hexCode.length === 3
      ? Array.prototype.map.call(hex, chr => chr + chr).join('')
      : hexCodes[hexCode]
      ? hexCodes[hexCode]
      : `${hexCode}000000`.slice(0, 6);
  const color = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
  const rgb = color
    ? [parseInt(color[1], 16), parseInt(color[2], 16), parseInt(color[3], 16)]
    : [0, 0, 0];
  const a =
    typeof opacity === 'number'
      ? opacity > 1
        ? opacity / 100
        : opacity
      : opacity.includes('%')
      ? parseInt(opacity.replace('%', ''), 10)
      : parseInt(opacity, 10);
  return `${rgb.join(',')},${a}`;
};
